import type { LevelObjectPlacement } from '../level/itemsLayout';
import { scaleLayoutSvgX } from '../level/layoutViewBox';
import {
  RUNNER_MARKER_SIZE_S,
  RUNNER_REF_VIEWBOX_WIDTH,
  RUNNER_STATIC_OBSTACLE_SIZE_SCALE,
} from './runnerConstants';
import type { RunnerObstacle, RunnerViewBox } from './runnerTypes';

/** Радиус орбиты в SVG user units (совпадает с S). Подкручивается константой. */
export const MONA_MOVING_ORBIT_RADIUS_SVG = scaleLayoutSvgX(140);

/** Центр орбиты ниже viewBox, чтобы кольцо выезжало снизу экрана. */
export const MONA_MOVING_ORBIT_CENTER_LANE = -0.1;

/** Период одного оборота, сек. */
export const MONA_MOVING_ORBIT_DURATION_SEC = 6;

/** Moving-спрайт: +100% к базовому размеру static. */
export const MONA_MOVING_SIZE_MUL = 6;

export function monaObstacleSizeS(viewBoxWidth: number): number {
  return (
    RUNNER_MARKER_SIZE_S *
    RUNNER_STATIC_OBSTACLE_SIZE_SCALE *
    (viewBoxWidth / RUNNER_REF_VIEWBOX_WIDTH)
  );
}

export function monaMovingSizeS(viewBoxWidth: number): number {
  return monaObstacleSizeS(viewBoxWidth) * MONA_MOVING_SIZE_MUL;
}

/** Layout-moving Моны: орбита вокруг точки ниже экрана (X из лейаута), фиксированный масштаб. */
export function buildMonaMovingObstacle(
  item: LevelObjectPlacement,
  viewBox: RunnerViewBox,
): RunnerObstacle {
  const sizeS = monaMovingSizeS(viewBox.width);
  const radiusS = MONA_MOVING_ORBIT_RADIUS_SVG;
  const radiusLane = viewBox.height > 0 ? radiusS / viewBox.height : 0;
  return {
    id: item.id,
    anchorS: item.s,
    consumed: false,
    spriteKey: 'mona_moving',
    hitbox: {
      centerS: item.s + radiusS,
      centerLane: MONA_MOVING_ORBIT_CENTER_LANE,
      widthS: sizeS,
      heightLane: sizeS / viewBox.height,
    },
    motion: {
      kind: 'orbit',
      centerS: item.s,
      centerLane: MONA_MOVING_ORBIT_CENTER_LANE,
      radiusS,
      radiusLane,
      durationSec: MONA_MOVING_ORBIT_DURATION_SEC,
      elapsedSec: 0,
    },
  };
}
